// extracted by mini-css-extract-plugin
export var container = "_em-0";
export var icon = "_em-1";
export var text = "_em-2";